import React, { Component } from 'react';
import {connect} from 'react-redux'
import asyncWrapper from '../../../../../../shared/javascripts/hocs/asyncWrapper'
import Loading from '../../../../../../shared/javascripts/components/Loading'
import { Chart } from "react-google-charts";
import FontAwesome from 'react-fontawesome'

import UserProgressApi from '../../../api/UserProgressApi'

class GenreScore extends Component {
  constructor(props) {
    super(props)
    this.state = {data: [], isUpdating: false}
  }

  fetchScore() {
    UserProgressApi.fetchGenreScore(this.props.filterOptions)
      .then(this.props.handleErrors)
      .then(response => {
        this.setState({data: response, isUpdating: false},
          ()=>this.props.setLoadingNew(false)
        )
      }).catch(error => console.log(error))
  }

  componentDidMount() {
    this.fetchScore()
  }

  componentDidUpdate(prevProps) {
    if(JSON.stringify(this.props.filterOptions) !== JSON.stringify(prevProps.filterOptions)) {
      this.setState({isUpdating: true}, () => this.fetchScore())
    }
  }

  render() {
    if(this.props.loading) {return <Loading />}

    return (
      <div className="GenreScore">
        <div className='updating'>{this.state.isUpdating ? <code><FontAwesome name='spinner' spin /> Updating...</code> : <code></code>}</div>
        <Chart
          chartType="ComboChart"
          width={'100%'}
          data={this.state.data}
          options={{
              title: 'Genre Points Scored',
              chartArea: { width: '60%' },
              "vAxis": {
                "title": "Percentage(%)",
                minValue: 0,
                maxValue: 100,
                viewWindow: {
                  min: 0,
                  max: 100
                }
              },
              "hAxis": {"title": "Genre"},
              "seriesType": "bars"
            }}
        />
      </div>
    )
  }
}

GenreScore = asyncWrapper(GenreScore)

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(GenreScore)



// WEBPACK FOOTER //
// ./src/reports/general/javascripts/components/User/Scores/GenreScore.jsx